/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */

import { USER_SCOPE_E } from './user-role.enum';

// 需要下发scope的场景
export const NEED_SEND_USER_SCOPE_LIST = [USER_SCOPE_E.LOCAL, USER_SCOPE_E.LDAP];
